import { storeAnswer } from '../../../services/manager';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/Button';
import Markdown from '../../../components/Markdown';
import SessionScreen from '.././SessionScreen';
import useValidation from '../../../hooks/useValidation';

export default function Screen() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [val] = useState('');
  const validation = useValidation(val, 'min:3');

  async function answer() {
    await storeAnswer('7', t('screens:7.uuid'), validation.value);
    navigate('/session/8', { replace: true });
  }

  const actions = (<>
    <Button label={t('yes')} variant="primary" onClick={() => answer()} />
    <Button label={t('no')} variant="primary" onClick={() => answer()} />
  </>);

  return (
    <SessionScreen
      screen="7"
      title={`${t('screens:7.step')} ${t('screens:7.title')}`}
      chapter={2}
      progress={33}
      audio={t('screens:7.audio')}
      actions={actions}
    >
      <Markdown value={t('screens:7.text')} />
    </SessionScreen>
  );
};
